const getFormFieldTokens = (tokens) => {
    return {
        formField: tokens.component.formField,
        label: tokens.component.label,
        spacing: tokens.semantic.spacing,
    };
};
const formControl = (tokens) => {
    const { formField, label, spacing } = getFormFieldTokens(tokens);
    return {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "inherit",
                    fontSize: label.formField.fontSize.value,
                    lineHeight: label.formField.lineHeight.value,
                    marginBottom: formField.label.gap.value,
                    "&.Mui-error": {
                        color: "inherit",
                    },
                    "&.MuiFormLabel-colorInfo": {
                        color: formField.hint.color.value,
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: formField.hint.fontSize.value,
                    lineHeight: formField.hint.lineHeight.value,
                    color: formField.hint.color.value,
                    marginLeft: spacing.none.value,
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    gap: label.checkbox.gap.value,
                    marginLeft: 0,
                    ".MuiFormControlLabel-label": {
                        fontSize: label.checkbox.fontSize.value,
                        lineHeight: label.checkbox.lineHeight.value,
                        fontWeight: label.checkbox.fontWeight.value,
                        color: label.formField.color.value,
                        "&.Mui-disabled": {
                            color: label.checkbox.disabled.color.value,
                        },
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    gap: formField.label.gap.value,
                    "& .MuiSelect-iconOpen": {
                        transform: "none",
                    },
                    ".MuiFormLabel-root": {
                        marginBottom: 0,
                    },
                    " &:has(.MuiFormHelperText-root)": {
                        "+ .MuiFormLabel-root": {
                            marginTop: formField.label.gap.value,
                            marginBottom: spacing.none.value,
                        },
                    },
                },
            },
        },
    };
};
export default formControl;
//# sourceMappingURL=formControl.js.map